"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_router_1 = require("vue-router");
var Home_vue_1 = require("../views/Home.vue");
var routes = [
    {
        path: "/",
        name: "Home",
        component: Home_vue_1.default,
    },
    {
        path: "/kefu",
        name: "Kefu",
        component: Home_vue_1.default,
    },
];
var router = vue_router_1.createRouter({
    history: vue_router_1.createWebHistory(window.__POWERED_BY_QIANKUN__ ? "/chat" : "/"),
    routes: routes,
});
exports.default = router;
